// extracted by mini-css-extract-plugin
export default {"address":"Address_address__Hk5CG"};